import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SerialSequenceDeleteModal } from './SerialSequenceDeleteModal'

type SerialSequenceDeleteActivityProps = {
  refetchQuery: string
  serialSequenceId: string
}

export const SerialSequenceDeleteActivity: ActivityComponent<SerialSequenceDeleteActivityProps> = (
  data
) => {
  const { open, closeActivity } = useActivity()

  return (
    <SerialSequenceDeleteModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      serialSequenceId={Number(data.serialSequenceId)}
    />
  )
}
